import jwt_decode from "jwt-decode";

const getIsUs = () => {
    const token = localStorage.getItem("token");
    if (!token) {
        return false;
    }

    let userToken;
    try {
        userToken = jwt_decode(token);
    } catch {
        return false;
    }

    const roles = Array.isArray(userToken?.role)
        ? userToken.role
        : [userToken?.role ?? "User"];

    const hasAccessUs = roles.some((role) =>
        role.toUpperCase().includes("ACCESSUS")
    );

    return hasAccessUs;
};

export default getIsUs;
